// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__-sAcD","alert":"SettungsInbox_alert__D_Q-_"};